module.exports = __webpack_public_path__ + "img/2_fineStaff_cwt.e1537304.png";